import { render, staticRenderFns } from "./report-card-english.vue?vue&type=template&id=25ea2507&"
import script from "./report-card-english.vue?vue&type=script&lang=js&"
export * from "./report-card-english.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports